export const billingRouter = [
  {
    path: "billing",
    name: "billing",
    component: () => import("../pages/billing/BillingPage.vue"),
    meta: { text: "$vuetify.layout.navigationSidebar.billing" },
  },
  {
    path: "/billing/all-invoices",
    name: "billing-all-invoices",
    component: () => import("../pages/billing/AllInvoicesPage.vue"),
    meta: {
      text: "$vuetify.billing.allInvoices",
      requiredRole: "Owner",
      parent: {
        name: "billing",
        path: "/billing",
        meta: { text: "$vuetify.layout.navigationSidebar.billing" },
      },
    },
  },
];
